import { setAppCode, setPlatformCode } from '@zhxk/web-components'

setAppCode('portal')
setPlatformCode('web')
